// @flow

import TimelinelyPlayer, { states } from "timelinely-player/TimelinelyPlayer";
import YoutubePlayerFactory from "youtube-player";
import type { VideoSources } from "timelinely-player/TimelinelyPlayer";

const defaultPlayerVars = {
    autoplay: 0,
    playsinline: 1,
    allowsInlineMediaPlayback: true,
    rel: 0, // No related videos playback
    showinfo: 0, // Hide video title and uploader
    iv_load_policy: 3, // Hide video annotations
    fs: 0, // Disable full screen
    modestbranding: 1 // hide YT logo from player bar but not the upper right corner
};

class YoutubePlayer extends TimelinelyPlayer {
    options: any;
    youtubePlayer: YoutubePlayerFactory;
    id: string;

    init(id: ?string, urls: ?VideoSources): void {
        if (!id) {
            throw new Error("YoutubePlayer expects to receive the video id");
        }
        this.id = id;

        const options = {
            videoId: this.id,
            playerVars: {
                ...defaultPlayerVars,
                controls: this.controls ? 1 : 0
            }
        };

        this.youtubePlayer = YoutubePlayerFactory(this.element, options);
    }

    play(): Promise<void> {
        return this.youtubePlayer.playVideo();
    }

    pause(): Promise<void> {
        return this.youtubePlayer.pauseVideo();
    }

    seekTo(seconds: number): Promise<void> {
        return this.youtubePlayer.seekTo(seconds);
    }

    get duration(): Promise<number> {
        return this.youtubePlayer.getDuration();
    }

    get currentTime(): Promise<number> {
        return this.youtubePlayer.getCurrentTime();
    }

    get bufferedPercentage(): Promise<number> {
        return this.youtubePlayer.getVideoLoadedFraction();
    }

    get volume(): Promise<number> {
        return this.youtubePlayer.getVolume();
    }

    set volume(volume: any): Promise<void> {
        return this.youtubePlayer.setVolume(volume);
    }

    get state(): Promise<string> {
        return new Promise((resolve: Function) =>
            this.youtubePlayer
                .getPlayerState()
                .then(state =>
                    resolve(state === 1 ? states.PLAYING : states.PAUSED)
                )
        );
    }

    get iframe(): Promise<HTMLIFrameElement> {
        return this.youtubePlayer.getIframe();
    }

    onChangeState(callback: Function): void {
        this.youtubePlayer.on("stateChange", event => {
            callback({
                state:
                    event.data === 0
                        ? states.ENDED
                        : event.data === 1
                        ? states.PLAYING
                        : states.PAUSED
            });
        });
    }

    cleanup() {}
}

export default YoutubePlayer;



// WEBPACK FOOTER //
// ./src/timelinely-player/players/YoutubePlayer.js